// extracted by mini-css-extract-plugin
export default {"box":"root_header-module__box___GHBJS","content":"root_header-module__content___ozXtS","close":"root_header-module__close___vpKIL"};